module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-role-edit"
  }, [_c('div', {
    staticClass: "row column card pt-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Role Name"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.role.name),
      expression: "role.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.role.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.role, "name", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Role Description"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.role.description),
      expression: "role.description"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.role.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.role, "description", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Permissions"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.role.menu),
      expression: "role.menu"
    }],
    attrs: {
      "multiple": "multiple"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.role, "menu", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "menu_overview"
    }
  }, [_vm._v("Overview")]), _c('option', {
    attrs: {
      "value": "menu_todo"
    }
  }, [_vm._v("Todo's")]), _c('option', {
    attrs: {
      "value": "menu_customers"
    }
  }, [_vm._v("Customers")]), _c('option', {
    attrs: {
      "value": "menu_booking"
    }
  }, [_vm._v("Booking")]), _c('option', {
    attrs: {
      "value": "menu_billing"
    }
  }, [_vm._v("Billing")]), _c('option', {
    attrs: {
      "value": "menu_assets"
    }
  }, [_vm._v("Assets")]), _c('option', {
    attrs: {
      "value": "menu_support"
    }
  }, [_vm._v("Support")])])])])]), _c('div', {
    staticClass: "row column"
  }, [_c('ActionButton', {
    attrs: {
      "action": _vm.save
    }
  }, [_vm._v("Save")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b3ed9aa6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/RoleEdit.vue
// module id = 2505
// module chunks = 1